module.exports = __webpack_public_path__ + "static/media/illustration-3.650a720f.png";